export const bthHover =
  'data-[hover=true]:bg-white data-[present-true]:bg-white data-[hover=true]:border-2 data-[present-true]:border-2  data-[hover=true]:text-black data-[present-true]:text-black transition-background duration-300'
